import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
//
import { environment } from '@env/environment';
//
import { map } from 'rxjs/operators';
//
import { HttpUtils } from '@common2/utils/http.utils';

@Injectable({ providedIn: 'root' })
export class StatisticsProvider2 {
    private readonly rootReporting = `${environment.envVar.REPORTING_URL}/companies`;
    private readonly rootApi = `${environment.envVar.API_URL}/admin/companies`;
    private readonly rootStats = `${environment.envVar.API_URL}/stats`;

    constructor(
        private readonly http: HttpClient,
    ) { }

    /**
     *
     */
    getCampList(companyId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootReporting}/${companyId}/camps`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }

    /**
     *
     */
    getContentList(companyId: number, campId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootApi}/${companyId}/camps/${campId}/contents/history`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }

    /**
     *
     */
    getContentInstanceList(companyId: number, campId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootReporting}/${companyId}/camps/${campId}/contents`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }

    /**
     *
     */
    getContentUserList(companyId: number, campId: number, contentId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootApi}/${companyId}/camps/${campId}/contents/${contentId}/users/history`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }

    /**
     *
     */
    getContentSubscriptionList(companyId: number, contentId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootReporting}/${companyId}/contents/${contentId}/subscriptions`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }

    /**
     *
     */
    getContentUsersSubscriptionList(companyId: number, userId: number, params: any = {}) {
        return this.http.post<any>(`${this.rootReporting}/${companyId}/contents/users/${userId}/subscriptions`, params, {
            observe: 'body',
        });
    }

    /**
     *
     */
    getContentUserStatList(context: string, courseId: number, userId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootStats}/${context}/${courseId}/user/${userId}`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }

    /**
     *
     */
    getContentSubscriptionActivityList(companyId: number, contentId: number, accountId: number, params: any = {}) {
        return this.http.get<any>(`${this.rootReporting}/${companyId}/contents/${contentId}/subscriptions/${accountId}/activities`, {
            observe: 'response',
            params: HttpUtils.getHttpParams(params),
        }).pipe(
            map((response: HttpResponse<any>) => response.body)
        );
    }
}
